import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type ReqBlock = {
  tag: string;
  title: string;
  lines: ReadonlyArray<{ text: string; strong?: string }>;
};

const BLOCKS: ReadonlyArray<ReqBlock> = [
  {
    tag: 'Web',
    title: 'Navigateur moderne',
    lines: [
      { text: 'Chrome 100+, Edge 100+, Firefox 100+, ', strong: 'Safari 15+' },
      { text: 'Connexion Internet ', strong: 'basique (2G/3G accepté)' },
      { text: "PWA installable sur écran d'accueil Android/iOS" },
      { text: 'Aucune installation, aucune mise à jour à gérer' },
    ],
  },
  {
    tag: 'Desktop',
    title: 'PC entrée de gamme OK',
    lines: [
      { text: 'Windows 10+, macOS 11+, ', strong: 'Ubuntu 20.04+' },
      { text: 'RAM ', strong: '2 Go' },
      { text: 'CPU dual-core x64 ou Apple Silicon' },
      { text: "500 Mo d'espace disque" },
      { text: 'Imprimante ESC/POS supportée (USB ou Bluetooth)' },
    ],
  },
  {
    tag: 'Mobile',
    title: 'Android 8+ · simple',
    lines: [
      { text: 'Android ', strong: '8.0+' },
      { text: 'iOS ', strong: 'en préparation' },
      { text: 'RAM 2 Go, 200 Mo libre' },
      { text: 'Caméra pour scanner les codes-barres' },
      { text: 'Bluetooth pour imprimantes portables' },
    ],
  },
];

export default function DownloadRequirementsV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-24">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Configuration minimale</SectionLabel>
        <h2 className="mt-3 font-marketing-display text-[clamp(32px,4.2vw,56px)] font-bold leading-[1] tracking-[-0.035em] text-white">
          Ce qu'il te <span className="text-lime-500">faut.</span>
        </h2>
        <p className="mt-4 max-w-[620px] font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          On a pensé aux PC des boutiques de quartier, pas aux MacBook Pro. Velko tourne sur du
          matériel modeste.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 md:grid-cols-3">
          {BLOCKS.map(({ tag, title, lines }) => (
            <div key={tag} className="flex min-h-[240px] flex-col gap-4 bg-charcoal-800 px-7 py-8">
              <span className="self-start border-[1.5px] border-lime-500 bg-lime-500 px-2 py-[3px] font-marketing-mono text-[10px] font-semibold uppercase tracking-[0.08em] text-charcoal-800">
                {tag}
              </span>
              <h4 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h4>
              <ul className="flex flex-col gap-2">
                {lines.map((line, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2.5 font-marketing-body text-[13px] leading-[1.55] text-charcoal-200"
                  >
                    <span className="mt-[2px] font-marketing-display font-bold text-lime-500">
                      →
                    </span>
                    <span>
                      {line.text}
                      {line.strong && (
                        <strong className="font-semibold text-white">{line.strong}</strong>
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
